import StatusProcessoService from '../_services/StatusProcessoService'
import { erroArrayToString } from '@/utils/trataErroRetornoApi'
import { statusProcessoModel } from '@/models/statusProcesso'

const state = {
  loading: false,
  loadingStore: false,
  statusProcessos: [],
  dropdownStatusProcesso: [],
  statusProcessoSelecionado: undefined,
  erros: '',
}

const getters = {
  GET_STATUSPROCESSOS : (state) => state.statusProcessos,
  GET_DROPDOWN: state => state.dropdownStatusProcesso,
  GET_ERROS: state => state.erros,
}

const mutations = {

  SET_LOADING_STORE: (state, ativo) => {
    state.loadingStore = ativo ? ativo : false
  },

  STATUSPROCESSO_SELECIONADO : (state, { statusProcesso }) => {
    state.statusProcessoSelecionado = Object.assign({}, statusProcesso)
  },

  SET_STATUSPROCESSOS : (state, { statusProcessos }) => {
    state.statusProcessos = statusProcessos
  },

  SET_DROPDOWN : (state, status) => {
    state.dropdownStatusProcesso = status
  },

  SET_ERROS : (state, erros) => {
    state.erros = erros.erros
  },

  ERASE_ERROS : (state) => {
    state.erros = ''
  },

  RESET_SELECTED : state => state.statusProcessoSelecionado = undefined,

}

const actions = {

  LOAD_DROPDOWN : async ({commit}) => {
    commit('SET_DROPDOWN', [])
    commit('ERASE_ERROS')
    await StatusProcessoService.getDropDown()
    .then(response => {
      if (response.data.status) {
        var drop = [{value: '', text:''}]
        var obj = response.data.status_processos
        Object.keys(obj).forEach(function (item) {
          var array = { value: obj[item].id, text: obj[item].ds_situacao }
          drop.push(array)
        })
        commit('SET_DROPDOWN', drop)

      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    })
  },

  GET_STATUSPROCESSOS : async ({ commit }) => {
      commit('SET_STATUSPROCESSOS', { statusProcesso : []})
      commit('ERASE_ERROS')
      await StatusProcessoService.getStatusProcessos()
      .then(response => {
        if (response.data.status) {
          commit('SET_STATUSPROCESSOS', { statusProcessos : response.data.status_processos})
        } else if (response.data.erro) {
          commit('SET_ERROS', { erros: response.data.erro })
        }
      })
      .catch(error => {
        console.log(error)
        commit('SET_ERROS', { erros: 'Erro ao acessar api' })
        reject(error)
      })
  },

  GET_STATUSPROCESSO : async ({commit}, id) => {
    commit('ERASE_ERROS')
    await StatusProcessoService.getStatusProcesso(id)
    .then(response => {
      if (response.data.status) {
        commit('STATUSPROCESSO_SELECIONADO', { statusProcesso : response.data.status_processo })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    })

  },

  STORE_STATUSPROCESSO : async ({ commit, dispatch }, statusProcesso) => {
    commit('ERASE_ERROS')
    try {
      commit('SET_LOADING_STORE', true)
      if (!statusProcesso.id || !(statusProcesso.id > 0)) { 
        var response = await StatusProcessoService.postStatusProcesso(statusProcesso)
      } else {
        var response = await StatusProcessoService.putStatusProcesso(statusProcesso.id, statusProcesso)
      }

      if (response.data.status) {
        commit('STATUSPROCESSO_SELECIONADO', { statusProcesso : response.data.status_processo })
        await dispatch('GET_STATUSPROCESSOS')

      } else if (!response.data.status && response.data.validacao) {
        var erros = erroArrayToString(response.data.erros)
        commit('SET_ERROS', { erros: erros })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    } finally {
      commit('SET_LOADING_STORE', false)
    }
  },

  DELETE_STATUSPROCESSO : async ({ commit, dispatch }, statusProcesso) => {
    commit('ERASE_ERROS')
    try {
      var response = await StatusProcessoService.deleteStatusProcesso(statusProcesso.id)

      if (response.data.status) {
        await dispatch('GET_STATUSPROCESSOS')

      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    }
  },

  STATUSPROCESSO_SELECIONADO : async ({dispatch, commit}, id) => {
    if (id > 0) { 
      await dispatch('GET_STATUSPROCESSO', id)
    } else {
      var obj = new statusProcessoModel.statusProcesso()
      await commit('STATUSPROCESSO_SELECIONADO', { statusProcesso: obj })
    }
  },

  RESET_SELECTED : ( {commit} ) => { commit('RESET_SELECTED') },

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
} 


// WEBPACK FOOTER //
// ./src/views/StatusProcesso/_store/index.js